module.exports = __webpack_public_path__ + "img/boy.687086d9.png";